// Card 1854540586736944835 — o rótulo que o usuário lê é "Mirezi".
//
// ── por que este arquivo é patch, e não configuração ────────────────────────────────────────
//
// O servidor TEM um `server.name` (`core/config/config.ts:26`), e ele é declarado pelo
// `cli/config-affine.js`. Ele sozinho NÃO resolve, e a razão está na linha de baixo: a versão
// do upstream **concatenava** o nome configurado ao rótulo fixo —
//
//     serverName && serverName !== DEFAULT ? `${DEFAULT} (${serverName})` : DEFAULT
//
// — de modo que `server.name = "Mirezi"` produzia, na tela de login e no cartão do workspace,
// **"AFFiNE Self-hosted (Mirezi)"**. A marca continuava lá, e a configuração parecia ter
// funcionado. Foi medido no `dev` antes de escrever isto.
//
// ── por que ele é o ponto certo ─────────────────────────────────────────────────────────────
//
// Três telas chamam `getSelfHostedServerName()`: `sign-in.tsx`, `sign-in-with-password.tsx` e
// `workspace-selector/workspace-card`. Editar as três seria três arquivos deles e três lugares
// podendo divergir. Aqui é UM (Regra #9), e é o arquivo mais frio do conjunto: medido no
// repositório do upstream em 2026-09-01, **1 commit desde que nasceu** (2026-07-03).
//
// ⚠️ E o `'AFFiNE Self-hosted'` continua citado abaixo DE PROPÓSITO. Ele é o valor que o
// SERVIDOR devolve quando `server.name` não está declarado (`core/config/resolver.ts:77`) — o
// estado de um ambiente cujo bundle já foi atualizado e cuja configuração ainda não. Sem
// reconhecê-lo aqui, esse ambiente mostraria **"Mirezi (AFFiNE Self-hosted)"**: o defeito de
// antes, com as duas marcas em vez de uma. Reconhecendo, ele degrada para "Mirezi" — que é o
// certo enquanto a configuração não chega, e continua certo depois.

export const DEFAULT_SELF_HOSTED_SERVER_NAME = 'Mirezi';

/** O rótulo que o upstream usa quando `server.name` não foi declarado. */
const NOME_HERDADO_DO_UPSTREAM = 'AFFiNE Self-hosted';

export function getSelfHostedServerName(serverName?: string | null) {
  // ⚠️ O `trim()` entrou no card 1864175759736702612, e quem o encontrou foi o teste de
  // PARIDADE com o gêmeo do servidor (`doc-renderer/tuninho/nome-do-servidor.ts`) — na
  // primeira execução dele. Sem ele, um `server.name` com só espaços passava pelo `!serverName`
  // (string de espaços é truthy) e era devolvido inteiro: a tela de login e o cartão do
  // workspace mostrariam um nome EM BRANCO, sem erro nenhum. É a regra 8.37 — `preenchida` não
  // é `certa` — no formato mais barato que ela tem.
  const nome = serverName?.trim();
  if (!nome || nome === NOME_HERDADO_DO_UPSTREAM) {
    return DEFAULT_SELF_HOSTED_SERVER_NAME;
  }
  // Um nome próprio declarado pelo operador (por ex. para distinguir dois ambientes) vale
  // sozinho. Concatenar devolveria o defeito que este arquivo existe para remover.
  return nome;
}
